<template lang="pug">
<router-view />
</template>

<script>
import './init'

export default {
  name: 'App',
  created () {
    this.$store.dispatch('Socket/init')
  },

  computed: {
    authenticated: {
      get () {
        return this.$store.state.User.authenticated
      }
    }
  },
  methods: {
  },
  watch: {
    authenticated (val) {
      const context = this.$store
      if (val) {
        setTimeout(() => {
          context.dispatch('Socket/enroll')
        }, 1000)
      } else {
        context.dispatch('Socket/unenroll')
      }
    }
  }
}
</script>

<style>
</style>
